// extracted by mini-css-extract-plugin
module.exports = {"text":"input-module--text--2VpGY","form":"input-module--form--3C6cD","select":"input-module--select--12WM6","privacy":"input-module--privacy--QAMFz"};